import React from 'react';
import Immutable from 'immutable';
import mime from 'mime-types';
import './style.scss';

const Picture = ({ src, className, onLoadFunction, imageRef, includeWebP, ...props }) => {
  const attrs = {
    className,
    typeof: 'foaf:Image',
    ...props,
  };

  const onLoad = (e) => {
    if (onLoadFunction) {
      onLoadFunction(e);
    }
  };

  if (Immutable.Iterable.isIterable(Immutable.fromJS(src))) {
    // Sources have to be defined in a descending order.
    // We sort them from best to worst quality.
    const sources = Immutable.fromJS(src)
      .toOrderedMap()
      .sortBy((url, breakpoint) => parseInt(breakpoint))
      .reverse();

    const fallback = sources.valueSeq().first();

    let renderedSourcesWebP = [];
    if (includeWebP) {
      /* eslint-disable react/no-array-index-key */
      renderedSourcesWebP = sources.map((url, breakpoint) => {
        const webpUrl = url.replace(/\.(png|gif|jp(e?)g)/, '.webp');
        return (
          <source
            key={breakpoint}
            srcSet={webpUrl}
            type={mime.lookup(webpUrl.replace(/\?.*/, ''))}
            media={`screen and (min-width: ${breakpoint}px)`}
          />
        );
      }).valueSeq();
    }

    /* eslint-disable react/no-array-index-key */
    const renderedSources = sources.map((url, breakpoint) => (
      <source
        key={breakpoint}
        srcSet={url}
        type={mime.lookup(url.replace(/\?.*/, ''))}
        media={`screen and (min-width: ${breakpoint}px)`}
      />
    )).valueSeq();

    return (
      <picture onLoad={(e) => onLoad(e)}>
        {renderedSourcesWebP}
        {renderedSources}

        {/* eslint-disable jsx-a11y/alt-text */}
        <img ref={imageRef} src={fallback} {...attrs} />
      </picture>
    );
  }

  if (includeWebP) {
    if (src) {
      const webpUrl = src.replace(/\.(png|gif|jp(e?)g)/, '.webp');
      return (
        <picture onLoad={(e) => onLoad(e)}>
          <source
            srcSet={webpUrl}
            type={mime.lookup(webpUrl.replace(/\?.*/, ''))}
          />
          <source
            srcSet={src}
            type={mime.lookup(src.replace(/\?.*/, ''))}
          />
          <img ref={imageRef} src={src} {...attrs} />
        </picture>
      );
    }
  }

  return (
    <img onLoad={(e) => onLoad(e)} ref={imageRef} src={src} {...attrs} />
  );
};

export default Picture;
